import React from 'react';

import styles from './AdminOnboardingChecklist.module.scss';

import { gettingStartedRightSideBarAtom, miniGettingStartedPopupAtom } from 'showMessageMenuAtom';
import { useAtom } from 'jotai';
import { ReactComponent as XIcon } from 'assets/img/close.svg';
import CheckMarkIcon from 'elements/CheckMarkIcon/CheckMarkIcon';
import { ReactComponent as CheckIcon } from 'containers/createGroup/check.svg';

interface IAdminOnboardingChecklist {
  groupData: any
};

const AdminOnboardingChecklist: React.FC<IAdminOnboardingChecklist> = ({ groupData }) => {
  const [isOpen, setIsOpen] = useAtom(miniGettingStartedPopupAtom);
  const [hideBtn, setHideBtn] = React.useState<boolean>(false);
  const [, setIsRightSideBarOpen] = useAtom(gettingStartedRightSideBarAtom);


  React.useEffect(() => {
    if (hideBtn) {
      setHideBtn(false);
    }
  }, [])


  return (
    <div className={`${styles.admin_onboarding_checklist} ${isOpen ? styles.isOpenWhite : styles.isNotOpenRight}`}>
      {
        !(
          (window.location.pathname.split("/").length >= 3) &&
          (window.location.pathname.split("/")[1] === 'settings')
        ) &&
        window.location.pathname.split("/")[1] !== "pages-preview" &&
        <button className={`${(isOpen || hideBtn) ? styles.Notopen : styles.admin_onboarding_checklist__button}`} >
          <div onClick={() => setIsOpen(true)} className={styles.icon_text}>
            <div className={styles.check_icon}>
              <CheckIcon />
            </div>
              <span className={styles.admin_onboarding_checklist__button_text}>Getting Started</span>

            </div>
            <button className={styles.smallCloseButton} onClick={() => setHideBtn(true)}><XIcon /></button>
          </button>
      }

      <div className={`${isOpen ? styles.open : styles.Notopen}`}>
        <button className={styles.closeButton} onClick={() => setIsOpen(false)}><XIcon /></button>

        <div className={styles.bannerBig}>

          <div className={styles.banner}>
            <div className={styles.banner__left}>
              <img src='https://static.group.app/assets/Dornubari.png' alt="Dornubari's Banner" />
            </div>
          </div>
          <div className={styles.banner__right}>
            <p className={styles.banner__right_P}>
              Welcome to GroupApp! <br />Ready to build & launch your community?
            </p>
          </div>
        </div>

        <div className={styles.header}>
          <p className={styles.header__text}>
            Register for our free community launch blueprint training and discover how to launch your profitable, engaged community in just 30 days — without complex funnels or endless content creation.
          </p>
        </div>
        <div className={styles.modalContent}>

          <h3 className={styles.modalContent__header}>During this training, you'll learn: </h3>

          <div className={styles.modalContent__item}>
            <CheckMarkIcon themeColor='#27AE60' type='checkbox' />
            <p className={styles.modalContent__text}>
              How to package your expertise into a learning community offer.
            </p>
          </div>

          <div className={styles.modalContent__item}>
            <CheckMarkIcon themeColor='#27AE60' type='checkbox' />
            <p className={styles.modalContent__text}>
              How to develop a simple, focused learning environment that keeps members actively engaged.
            </p>
          </div>

          <div className={styles.modalContent__item}>
            <CheckMarkIcon themeColor='#27AE60' type='checkbox' />
            <p className={styles.modalContent__text}>
              How to launch your community and attract your founding members.
            </p>
          </div>

          <div className={styles.actions}>
            <button
              onClick={() => window.open('https://community.group.app/pages/free-live-training-blueprint', '_blank')}
              className={styles.demoButton}>Register for Free Training</button>
            <button
              className={styles.skipButton}
              onClick={() => {
                setIsOpen(false)
                setIsRightSideBarOpen(true)
              }}
            >View Setup Guide</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminOnboardingChecklist;